import { sendGaEvent } from './analytics';

type ItemDetailViewDataset = {
  itemDetailView?: string;
  itemId?: string;
  itemTitle?: string;
  platform?: string;
};

type ItemDetailViewParams = {
  item_id: string;
  item_title: string;
  platform: string;
};

const UNKNOWN_ITEM_TITLE = '(タイトル不明)';

type ItemDetailViewElement = {
  dataset: ItemDetailViewDataset;
};

function isItemDetailViewElement(value: unknown): value is ItemDetailViewElement {
  return typeof value === 'object' && value !== null && 'dataset' in value;
}

export function buildItemDetailViewParams(dataset: ItemDetailViewDataset): ItemDetailViewParams | null {
  const { itemId, itemTitle, platform } = dataset;
  if (!itemId || !platform) return null;
  return {
    item_id: itemId,
    item_title: itemTitle || UNKNOWN_ITEM_TITLE,
    platform,
  };
}

export function findItemDetailViewElement(doc: Document = document): ItemDetailViewElement | null {
  const candidate = doc.querySelector('[data-item-detail-view]');
  return isItemDetailViewElement(candidate) ? candidate : null;
}

export function trackItemDetailView(
  dataset: ItemDetailViewDataset,
  tracker: (eventName: string, params: ItemDetailViewParams) => boolean = sendGaEvent,
): boolean {
  const params = buildItemDetailViewParams(dataset);
  if (!params) return false;
  return tracker('item_detail_view', params);
}

export function initItemDetailViewTracking(doc: Document = document): void {
  const el = findItemDetailViewElement(doc);
  if (!el) return;
  trackItemDetailView(el.dataset);
}
